module.exports = __webpack_public_path__ + "7bd809fd3b652e10b47cb2f93adb9293.png";